import { apiPostAuth, apiGetAuth, apiPutAuth, apiDeleteAuth, apiPostAuthWithCustomHeadersResponseType } from '@/utils/api'
import { API_BULK } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  bulk_list: { 
    isLoading: false,
    data: {}
  },
  detail_bulk_id: {
    isLoading: false,
    data: {}
  },
  detail_bulk_code: {
    isLoading: false,
    data: {}
  },
  toggle_modal_add_edit_discard: {
    targetModals: false,
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false,
    modalSummary: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  },
  meta_detail_bulk_filter: {
    order_by: 'updated_at', 
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_BULK_LIST": (state, payload) => {
    state.bulk_list = payload
  },
  "SET_DETAIL_BULK_ID": (state, payload) => {
    state.detail_bulk_id = payload
  },
  "SET_DETAIL_BULK_CODE": (state, payload) => {
    state.detail_bulk_code = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  },
  "SET_META_DETAIL_BULK_FILTER": (state, payload) => {
    state.meta_detail_bulk_filter = payload
  }
}

const actions = {
  async getBulkList(context, payload) {
    try {
      context.commit('SET_BULK_LIST', { isLoading: true })
      const response = await apiGetAuth(API_BULK.LIST, payload)
      context.commit('SET_BULK_LIST', {
        isLoading: false,
        data: response.data
      })
      context.commit('SET_META_FILTER', payload)
    } catch (err) {
      context.commit('SET_BULK_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailBulkById(context, payload) {
    try {
      context.commit('SET_DETAIL_BULK_ID', { isLoading: true })
      const response = await apiGetAuth(API_BULK.BY_ID(payload))
      context.commit('SET_DETAIL_BULK_ID', {
        isLoading: false,
        data: response.data.data
      })
      return response
    } catch (error) {
      context.commit('SET_DETAIL_BULK_ID', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
      return error
    }
  },
  async getDetailBulkByCode(context, payload) {
    try {
      context.commit('SET_DETAIL_BULK_CODE', { isLoading: true })
      const response = await apiGetAuth(API_BULK.BY_CODE, payload)
      context.commit('SET_DETAIL_BULK_CODE', {
        isLoading: false,
        data: response.data
      })
      context.commit('SET_META_DETAIL_BULK_FILTER', payload)
    } catch (error) {
      context.commit('SET_DETAIL_BULK_CODE', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async exportTemplateIuran(context, payload) {
    try {
      const response = await apiPostAuthWithCustomHeadersResponseType(API_BULK.TEMPLATE_IURAN(payload))
      if(response.data) {
        return response
      }
      return false
    } catch (error) {
      notificationDanger(`Failed to export`)
    }
  },
  async createBulkEmployee(context, payload) {
    try {
      const response = await apiPostAuth(API_BULK.CREATE_BULK_EMPLOYEE, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async createBulkIuranEmployee(context, payload) {
    try {
      const response = await apiPostAuth(API_BULK.CREATE_BULK_IURAN, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async createBulkCompanySubdivision(context, payload) {
    try {
      const response = await apiPostAuth(API_BULK.CREATE_BULK_COMPANY_SUBDIVISION, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateProcessBulk(context, payload) {
    try {
      const response = await apiPutAuth(API_BULK.LIST, payload)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateCancelBulk(context, payload) {
    try {
      const response = await apiDeleteAuth(API_BULK.BY_ID(payload))
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_bulk_list: state => {
    return state.bulk_list
  },
  get_detail_bulk_id: state => {
    return state.detail_bulk_id
  },
  get_detail_bulk_code: state => {
    return state.detail_bulk_code
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  },
  meta_detail_bulk_filter: state => {
    return state.meta_detail_bulk_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
